import angular from 'angular';

angular
  .module('dematPlatform', [])

  .config([
    '$stateProvider',
    function($stateProvider) {
      $stateProvider.state('dematPlatform', {
        data: {
          authorizedRole: 'USER_BO'
        }
      });
    }
  ]);
